import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CommonFooter, MFAOptionsFooter } from "@faire/retailer-visitor-shared/components/AppSignIn/components/__internal__/EmailSentWaitingViewHelper";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { useIsNewMagicLinkExperience } from "@faire/retailer-visitor-shared/settings/useSettingSignInImprovements";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { trackSigninCheckEmailView } from "@faire/web-api--source/events/signin/view/checkEmail";
import { ISignInMagicLinkXP } from "@faire/web-api--source/indigofair/seo/ISignInMagicLinkXP";
import * as React from "react";
import { useEffect } from "react";
export var EmailSentScenario;
(function(EmailSentScenario) {
    EmailSentScenario["MAGIC_LINK"] = "MAGIC_LINK";
    EmailSentScenario["AUTO"] = "AUTO";
    EmailSentScenario["MFA"] = "MFA";
    EmailSentScenario["MFA_OPTIONS"] = "MFA_OPTIONS";
    EmailSentScenario["MFA_OPTIONS_EMAIL_SENT"] = "MFA_OPTIONS_EMAIL_SENT";
})(EmailSentScenario || (EmailSentScenario = {}));
var MFA_IMAGE = "https://cdn.faire.com/fastly/87316c85c84400611e38f24e1258c90ebff01dd489826f2b88626a384f328007.png";
var MFA_EMAIL_SENT_IMAGE = "https://cdn.faire.com/fastly/156f191b1cee0a924570a6b23d7d8c7c35d78bfa643d72f9a007fb030757cb32.png";
var useEmailSentScenarios = function(scenario, email, onComplete) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isOriginalText = useIsNewMagicLinkExperience(ISignInMagicLinkXP.Bucket.VARIANT_B);
    if (scenario === EmailSentScenario.MAGIC_LINK) {
        return {
            scenario: scenario,
            image: "https://cdn.faire.com/fastly/e03c75403abfe4cb2ac73c39c486469dc28371c6b0238869395c08eaba707f93.png",
            title: isOriginalText ? strictLocalize({
                id: "Yjlxwj",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Check your email"
                    }
                ]
            }) : strictLocalize({
                id: "ZCpAUS",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Magic link on its way!"
                    }
                ]
            }),
            subtitle: strictLocalize({
                id: "EoG4vW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "To sign in, use the link in the email we sent to "
                    },
                    {
                        type: 1,
                        value: "EmailFullyTranslatedSentence"
                    },
                    {
                        type: 0,
                        value: "."
                    }
                ]
            }, {
                EmailFullyTranslatedSentence: email
            }),
            footer: /*#__PURE__*/ _jsx(CommonFooter, {
                onComplete: onComplete,
                email: email,
                scenario: scenario
            })
        };
    } else if (scenario === EmailSentScenario.AUTO) {
        return {
            scenario: scenario,
            image: "https://cdn.faire.com/fastly/156f191b1cee0a924570a6b23d7d8c7c35d78bfa643d72f9a007fb030757cb32.png",
            title: strictLocalize({
                id: "dCsj66",
                defaultMessage: [
                    {
                        type: 0,
                        value: "We emailed you a link to help you sign back in"
                    }
                ]
            }),
            subtitle: strictLocalize({
                id: "+MZnyx",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Check "
                    },
                    {
                        type: 1,
                        value: "EmailFullyTranslatedSentence"
                    },
                    {
                        type: 0,
                        value: " for a link to sign in without a password."
                    }
                ]
            }, {
                EmailFullyTranslatedSentence: email
            }),
            footer: /*#__PURE__*/ _jsx(CommonFooter, {
                onComplete: onComplete,
                email: email,
                scenario: scenario
            })
        };
    }
    return undefined;
};
var EmailSentWaitingViewBase = function(param) {
    var title = param.title, subtitle = param.subtitle, footer = param.footer, image = param.image, scenario = param.scenario;
    useEffect(function() {
        trackSigninCheckEmailView(scenario.toLowerCase());
    }, [
        scenario
    ]);
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        noSpacing: true,
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: image,
                width: "100%",
                "data-test-id": "email-sent-waiting-img-".concat(scenario)
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                children: title
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: subtitle
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "3x"
            }),
            footer,
            /*#__PURE__*/ _jsx(Spacer, {
                size: {
                    mobileAndAbove: "3x",
                    tabletAndAbove: 0
                }
            })
        ]
    });
};
export var EmailSentWaitingView = function(param) {
    var onComplete = param.onComplete, _param_scenario = param.scenario, scenario = _param_scenario === void 0 ? EmailSentScenario.MAGIC_LINK : _param_scenario, email = param.email;
    var props = useEmailSentScenarios(scenario, email, onComplete);
    return /*#__PURE__*/ _jsx(EmailSentWaitingViewBase, _object_spread_props(_object_spread({}, props), {
        scenario: scenario
    }));
};
export var MFAOptionsEmailSentWaitingView = function(param) {
    var onComplete = param.onComplete, email = param.email, mfaTitle = param.mfaTitle, mfaDescription = param.mfaDescription, password = param.password;
    return /*#__PURE__*/ _jsx(EmailSentWaitingViewBase, {
        title: mfaTitle,
        subtitle: mfaDescription,
        image: MFA_EMAIL_SENT_IMAGE,
        scenario: EmailSentScenario.MFA_OPTIONS_EMAIL_SENT,
        footer: /*#__PURE__*/ _jsx(CommonFooter, {
            onComplete: onComplete,
            email: email !== null && email !== void 0 ? email : "",
            scenario: EmailSentScenario.MFA_OPTIONS_EMAIL_SENT,
            password: password
        })
    });
};
export var MFASentWaitingView = function(param) {
    var onComplete = param.onComplete, email = param.email, mfaTitle = param.mfaTitle, mfaDescription = param.mfaDescription, password = param.password;
    return /*#__PURE__*/ _jsx(EmailSentWaitingViewBase, {
        title: mfaTitle,
        subtitle: mfaDescription,
        image: MFA_IMAGE,
        scenario: EmailSentScenario.MFA,
        footer: /*#__PURE__*/ _jsx(CommonFooter, {
            onComplete: onComplete,
            email: email !== null && email !== void 0 ? email : "",
            scenario: EmailSentScenario.MFA,
            password: password
        })
    });
};
export var MFAOptionsView = function(param) {
    var email = param.email, password = param.password, userToken = param.userToken, mfaTitle = param.mfaTitle, mfaDescription = param.mfaDescription, mfaOptionsMemoized = param.mfaOptionsMemoized, onComplete = param.onComplete;
    return /*#__PURE__*/ _jsx(EmailSentWaitingViewBase, {
        title: mfaTitle,
        subtitle: mfaDescription,
        image: MFA_IMAGE,
        scenario: EmailSentScenario.MFA_OPTIONS,
        footer: /*#__PURE__*/ _jsx(MFAOptionsFooter, {
            email: email !== null && email !== void 0 ? email : "",
            scenario: EmailSentScenario.MFA_OPTIONS,
            onComplete: onComplete,
            mfaOptionsMemoized: mfaOptionsMemoized,
            password: password,
            userToken: userToken
        })
    });
};
